/**
 * Deep links into a page's documents browser: `?folder=<id>/<id>` lists the
 * folder ids from Contents (exclusive) down to the folder to open, and an
 * empty value opens Contents itself.
 */
const FOLDER_PARAM = "folder";

export const folderLink = (pagePath: string, folderIds: string[]) =>
	`${pagePath}?${FOLDER_PARAM}=${folderIds
		.map((id) => encodeURIComponent(id))
		.join("/")}`;

/** Folder ids from a deep link, or null when the URL has none. */
export const parseFolderParam = (search: string): string[] | null => {
	const value = new URLSearchParams(search).get(FOLDER_PARAM);
	return value === null ? null : value.split("/").filter(Boolean);
};

/** Whether the URL deep-links into the documents browser, so its tab should open. */
export const hasFolderParam = (search: string) =>
	parseFolderParam(search) !== null;

/** The query string without the deep link, for a browser that has opened it. */
export const withoutFolderParam = (search: string) => {
	const params = new URLSearchParams(search);
	params.delete(FOLDER_PARAM);
	const rest = params.toString();
	return rest ? `?${rest}` : "";
};
